import { handleClickOutside } from "./helpers/click-outside-handler";
import { removeOpenedClass } from "./helpers/remove-opened-class";

const SearchMenu = () => {
  const body = document.body;

  const searchWrapper = document.querySelector(".header__search-wrapper");
  const inputSearch = document.querySelector(".input-search");
  const inputCloser = document.querySelector(".input-search__close-btn");

  const menu = document.querySelector(".search-menu");
  const menuCloser = document.querySelector(".search-menu__closer");

  const mobileSearchOpener = document.querySelector(".header__mobile-search-opener");

  const openSearchWrapper = () => {
    searchWrapper.classList.add("opened");
  };

  const closeSearchWraper = () => {
    searchWrapper.classList.remove("opened");
    inputSearch.value = ""; 
  };

  const openMenu = () => {
    menu.classList.add("opened");
    body.classList.add("no-scroll");
    removeOpenedClass(menu, searchWrapper);

    handleClickOutside([searchWrapper, menu, inputSearch, mobileSearchOpener], () => {
      closeMenu();
      closeSearchWraper();
    });
  };

  const closeMenu = () => {
    menu.classList.remove("opened");
    body.classList.remove("no-scroll");
    inputSearch.value = ""; 
  };

  if (inputSearch) {
    inputSearch.addEventListener("click", openSearchWrapper);

    inputSearch.addEventListener("input", () => {
      if (inputSearch.value.trim().length >= 3) {
        openMenu();
        openSearchWrapper();
      }
    });
  }

  if (menuCloser) {
    menuCloser.addEventListener("click", () => {
      closeMenu();
      closeSearchWraper();
     });
  }

  if (inputCloser) {
    inputCloser.addEventListener("click", (e) => {
      e.stopPropagation();
      closeMenu();
      closeSearchWraper();
    });
  }

  if (mobileSearchOpener) {
    mobileSearchOpener.addEventListener("click", () => {
      openSearchWrapper();
      removeOpenedClass(searchWrapper);
      if (inputSearch) {
        inputSearch.focus();
      }
    });
  }

  // if (searchWrapper.classList.contains("opened")) {
  //   handleClickOutside([searchWrapper, menu, inputSearch, mobileSearchOpener], () => {
  //     closeMenu();
  //     closeSearchWraper();
  //   });
  // }

  // handleClickOutside([searchWrapper, menu, inputSearch, mobileSearchOpener], () => {
  //   closeMenu();
  //   closeSearchWraper();
  // });

  // document.addEventListener("click", (e) => {
  //   const isInputSearch = e.target.closest(".input-search");
  //   const isSearchMenu = e.target.closest(".search-menu");
  //   const isSearchWrapper = e.target.closest(".header__search-wrapper");
  //   const mobileSearchOpener = e.target.closest(".header__mobile-search-opener");
  //   const isMenu = e.target.closest(".navigation-menu");
  //   const isOpener = e.target.closest(".header__menu-opener-link");
  //   const isBurgerOpener = e.target.closest(".header__burger-opener");
  //   const isBurgerMenu = e.target.closest(".burger-menu");

  //   if (!isMenu && !isOpener && !isBurgerOpener && !isBurgerMenu && !isSearchMenu && !isInputSearch && !isSearchWrapper && !mobileSearchOpener) {
  //     closeMenu();
  //     closeSearchWraper();
  //   }
  // });
};

export default SearchMenu;
